var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"global-tip"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"content"},[_vm._v(_vm._s(_vm.content))]),_vm._v(" "),_c('div',{staticClass:"global-tip-button",on:{"click":_vm.click}},[_vm._v(_vm._s(_vm.confirmText))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-620d31f7","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./build/loaders/resource-error-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/GlobalTip/GlobalTip.vue
// module id = null
// module chunks = 